import { useParams, Navigate } from "react-router-dom";
import SeoLandingPage from "@/components/SeoLandingPage";
import { getService, buildServicePage, CITIES, SERVICES, SITE, PROVIDER } from "@/seoData";

export default function ServicePage() {
  const { slug } = useParams();
  const svc = getService(slug);
  if (!svc) return <Navigate to="/" replace />;

  const name = svc.name;
  const canonical = `${SITE}/services/${slug}`;
  const { title, description, h1, lead, sections, faqs } = buildServicePage(svc);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: name,
      provider: PROVIDER,
      areaServed: { "@type": "AdministrativeArea", name: "San Diego County, CA" },
      name: `${name} in San Diego, CA`,
      description,
      url: canonical,
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE + "/" },
        { "@type": "ListItem", position: 2, name: name, item: canonical },
      ],
    },
  ];

  const related = [
    ...(svc.relatedLinks || []),
    ...SERVICES.filter((s) => s.slug !== slug && !(svc.relatedLinks || []).some((r) => r.to === `/services/${s.slug}`)).slice(0, 8).map((s) => ({ to: `/services/${s.slug}`, label: s.name })),
    ...CITIES.slice(0, 4).map((c) => ({ to: `/junk-removal/${c.slug}`, label: `Junk Removal ${c.name}` })),
  ];

  const config = {
    h1,
    crumb: name,
    lead,
    benefitsTitle: `${name} — and everything else we haul`,
    sections,
    seo: { title, description, canonical, jsonLd },
    faqs,
    related,
    relatedTitle: "Other services & areas we cover",
    serviceSlug: slug,
    quoteVariant: slug === "commercial-junk-removal" ? "commercial" : "seo",
  };

  return <SeoLandingPage config={config} />;
}
